import router from './router'
import store from './store'
import {
  Message
} from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {
  getAccessToken,
  getCustomBase64,
  getMenuAuth,
  getToken
} from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import Layout from '@/layout'
import Cookies from 'js-cookie'
import { isMap } from 'lodash'

NProgress.configure({
  showSpinner: false
}) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  console.log('permission.js beforeEach', '开始走了beforeEach钩子')
  // start progress bar
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasCustomBase64 = getCustomBase64()
  console.log('permission.js to.path', to.path)
  console.log('permission.js hasCustomBase64', hasCustomBase64)
  if (hasCustomBase64) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({
        path: '/'
      })
      NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
    } else {
      const hasMenuIdList = store.getters.menuIdList && store.getters.menuIdList !== '' && store.getters.menuIdList.length > 0
      console.log('store.getters.menuIdList', store.getters.menuIdList)

      if (hasMenuIdList) {
        console.log('hasMenus, 放行')
        next()
      } else {
        console.log('permission.js menuidlist 开始执行获取菜单和权限')
        // 获取所有菜单

        try {
          const menuList = await store.dispatch('global/getMenusTree')
          console.log('menuList', menuList)
          // 调整获取菜单
          var hotelInfo = JSON.parse(Buffer.from(hasCustomBase64, 'base64'))
          var accountID = hotelInfo.accountID
          var isAdmin = hotelInfo.isAdmin
          if (isAdmin) {
            var adminMenu = {
              'data': {
                'id': 900,
                'name': '超管菜单',
                'pageUrl': '',
                'sort': 900,
                'remarks': '{"path":"/admin"}'
              },
              'children': [{
                'data': {
                  'id': 901,
                  'marks': true,
                  'parentID': 900,
                  'name': '酒店管理',
                  'pageUrl': '/hotel/hotelList',
                  'sort': 1,
                  'remarks': '{"path":"hotelList","name":"HotelList"}'
                },
                'children': []
              },
              {
                'data': {
                  'id': 902,
                  'marks': true,
                  'parentID': 1,
                  'name': '菜单管理',
                  'pageUrl': '/basic/menu',
                  'sort': 2,
                  'remarks': '{"path":"menu","name":"Menu"}'
                },
                'children': []
              }
              ]
            }
            menuList.push(adminMenu)
          }
          const asyncRoutes = []
          menuList.forEach(item => {
            const temp = {}
            temp.path = JSON.parse(item.data.remarks).path
            temp.name = JSON.parse(item.data.remarks).name
            temp.component = Layout
            temp.alwaysShow = true
            temp.redirect = 'noRedirect'
            temp.meta = {
              id: item.data.id,
              title: item.data.name
            }
            temp.children = []
            if (item.children && item.children.length > 0) {
              item.children.forEach(childItem => {
                const child = {}
                child.path = JSON.parse(childItem.data.remarks).path
                child.component = (resolve) => require([`@/views${childItem.data.pageUrl}`], resolve)
                child.name = JSON.parse(childItem.data.remarks).name
                child.meta = {
                  id: childItem.data.id,
                  title: childItem.data.name
                }
                if (JSON.parse(childItem.data.remarks).type) {
                  if (JSON.parse(childItem.data.remarks).subtype) {
                    child.props = {
                      type: JSON.parse(childItem.data.remarks).type,
                      subtype: JSON.parse(childItem.data.remarks).subtype
                    }
                  } else {
                    child.props = {
                      type: JSON.parse(childItem.data.remarks).type
                    }
                  }
                }

                temp.children.push(child)
              })
            }
            asyncRoutes.push(temp)
            console.log('temp', temp)
          })
          localStorage.setItem('menuList', JSON.stringify(menuList))
          console.log('与权限组合之前的asyncRoutes: ', asyncRoutes)

          const roleMenus = await store.dispatch('user/getUserRoleMenus', { accountID, isAdmin })
          console.log('store.getters.menuIdList 2', store.getters.menuIdList)
          console.log('permission.js 在这里开始调用generateRoutes roleMenus', roleMenus)
          const menuIds = roleMenus.menuIDs
          if (!menuIds) {
            Message({
              message: '该账号没有权限 请联系管理员',
              type: 'error',
              duration: 2000
            })
          }
          const accessRoutes = await store.dispatch('permission/generateRoutesNew', {
            asyncRoutes,
            menuIds
          })
          console.log('permission.js accessRoutes', accessRoutes)
          // dynamically add accessible routes
          router.addRoutes(accessRoutes)
          next({
            ...to,
            replace: true
          })
        } catch (error) {
          console.log(error)
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          await store.dispatch('user/logout')
          // Message.error(error || 'Has Error')
          next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      }

      // const hasRoles = store.getters.roles && store.getters.roles.length > 0
      // console.log('permission.js hasRoles', hasRoles, store.getters.roles)
      // if (hasRoles) {
      //   console.log('permission.js 有roles 放行')
      //   next()
      // } else {
      //   console.log('permission.js 没有roles 开始执行getRoles')
      //   try {
      //     const roles = await store.dispatch('user/getRoles')
      //     console.log('permission.js 在这里开始调用generateRoutes 当前的roles是', roles)
      //     // generate accessible routes map based on roles
      //     const accessRoutes = await store.dispatch('permission/generateRoutesNew', roles.menuIDs)
      //     console.log('permission.js accessRoutes', accessRoutes)
      //     // dynamically add accessible routes
      //     router.addRoutes(accessRoutes)

      //     // hack method to ensure that addRoutes is complete
      //     // set the replace: true, so the navigation will not leave a history record
      //     next({
      //       ...to,
      //       replace: true
      //     })
      //   } catch (error) {
      //     console.log('permission.js error', error)
      //     // remove token and go to login page to re-login
      //     await store.dispatch('user/resetToken')
      //     Message.error(error || 'Has Error')
      //     next(`/login?redirect=${to.path}`)
      //     NProgress.done()
      //   }
      // }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
